import axios from 'axios';
import authHeader, { clearStoredUser } from '../AuthenticationService/AuthenticationHeader';
const API_URL = "/api/";

// Endpunkte, die der Server als permitAll führt und die typischerweise von nicht
// angemeldeten Benutzern aufgerufen werden. Hier darf kein (womöglich veraltetes)
// Token mitgeschickt werden - siehe Teamanmeldung, die ohne Login funktionieren muss.
const PUBLIC_URL_PREFIXES = ["teamregistration/", "login", "htmlExport", "public/", "template/"];

function isPublicUrl(url) {
    return PUBLIC_URL_PREFIXES.some((prefix) => url.startsWith(prefix));
}

function headersFor(url) {
    return isPublicUrl(url) ? {} : authHeader();
}

// Ein 401 heißt: das gespeicherte Token ist nicht (mehr) gültig - z.B. abgelaufen
// oder noch mit einer älteren Server-Signatur ausgestellt. Token verwerfen und den
// Request einmal anonym wiederholen; bei öffentlichen Endpunkten gelingt er dann,
// bei geschützten läuft der 401 wie gehabt in die Fehlerbehandlung der Komponente.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        var config = error.config;
        if (!error.response || error.response.status !== 401 || !config) {
            return Promise.reject(error);
        }
        clearStoredUser();
        var hadAuthorization = config.headers && config.headers.Authorization;
        if (!hadAuthorization || config.retriedWithoutAuthentication) {
            return Promise.reject(error);
        }
        config.retriedWithoutAuthentication = true;
        delete config.headers.Authorization;
        return axios.request(config);
    }
);

class ServerConnection {

    get(url, config = {}){
       var headers = headersFor(url);
       return axios.get(API_URL + url, { ...config, headers: headers });
    }
    post(url, body, config = {}){
        var headers = headersFor(url);
        headers['Content-Type'] = "application/json";
        return axios.post(API_URL + url, body, { ...config, headers: headers });
    }
    postFile(url, file, onUploadProgress){
        var headers = headersFor(url);
        headers['Content-Type'] = "multipart/form-data";
        let formData = new FormData();
        formData.append("file", file);

        return axios.post(API_URL + url, formData, {
          headers: headers,
          onUploadProgress
        });
    }
    put(url, body, config = {}){
        var headers = headersFor(url);
        headers['Content-Type'] = "application/json";
        return axios.put(API_URL + url, body, { ...config, headers:  headers});
    }
    delete(url, config = {}){
        var headers = headersFor(url);
        return axios.delete(API_URL + url, { ...config, headers:  headers});
    }

}
export default new ServerConnection();
